import Home from "../Home"


const MenClothing = () => {
  return (
    <Home url={"https://fakestoreapi.com/products/category/men's clothing"}/>
  )
}

export default MenClothing